import { _ as r } from "../internals/export.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { i as o } from "../internals/indexed-object.js";
import { t as i } from "../internals/to-indexed-object.js";
import { a as n } from "../internals/array-method-is-strict.js";
var s = t([].join);
r({
  target: "Array",
  proto: !0,
  forced: o != Object || !n("join", ",")
}, {
  join: function join(r) {
    return s(i(this), void 0 === r ? "," : r);
  }
});